'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var ScrollBox = require('osx-scrollview');
var Border = require('../common/LineModeBorder');
var styleHelper = require('../../helper/styleHelper');
var tool = require('../../helper/tool');
/*
 @Author : mengxiaojiang
 @CreateDate : 2016-3-31
 @Descript : 滚动区组件
 */
var ScrollView = React.createClass({
  ENABLED_DRAG: false,

  getInitialState: function () {
    return {
      scrollLeft: 0,
      scrollTop: 0,
      showScrollBar: false
    }
  },

  currentScrollPoints: {
    x: 0,
    y: 0
  },

  render: function () {
    var content = this.props.items[0];
    return (
      <div key="scrollView" style={{
        width: '100%',
        height: '100%',
        borderWidth: '1px',
        borderColor: styleHelper.getBorderColor(this.props),
        backgroundColor: styleHelper.getBackgroundColor(this.props),
        overflow: 'hidden',
        zIndex: this.props.zOrder
      }}
           // onMouseDown={this.onMouseDown}
           // onMouseUp={this.onMouseUp}
           // onMouseMove={this.onMouseMove}
           // onMouseLeave={this.onMouseLeave}
           onScroll={this.onSelfScroll}
      >
        <ScrollBox
          ref="scrollbox"
          id={this.props.controlID + '-scrollbox'}
          scrollTop={this.state.scrollTop}
          scrollLeft={this.state.scrollLeft}
          onScroll={this.onScroll}
          scrollBarStyle={this.props.showScrollBars ? 'show' : 'hide'}
          disableHScroll={!this.props.canHoriScroll}
          disableVScroll={!this.props.canVertScroll}
          dragToScroll={true}
        >
          <div ref="viewPort" style={{
            width: content.w,
            height: content.h,
            overflow: 'hidden'
          }}>
            {this.props.children}
          </div>
        </ScrollBox>


        {
          this.props.borderVisible &&
          <Border {...{borderVisible: true, borderColor: styleHelper.getBorderColor(this.props), zIndex: 2}}/>
        }
      </div>
    );
  },

  onSelfScroll: function (e) {
    e.stopPropagation();
  },

  onScroll: function (top, left) {
    //this.setState({
    //  scrollLeft: left,
    //  scrollTop: top
    //});
    if(!this.hasShow) {
      tool.setThumbOpaicty(ReactDOM.findDOMNode(this), 1);
      this.hasShow = true;
    }

    this.currentScrollPoints = {
      x: left,
      y: top,
    };

    this.startAutoSetState();
  },

  startAutoSetState: function () {
    var self = this;
    if (this.autoScrolltimeID)
      clearTimeout(this.autoScrolltimeID);
    this.autoScrolltimeID = setTimeout(function () {
      clearTimeout(self.autoScrolltimeID);
      self.setState({
        scrollLeft: self.currentScrollPoints.x,
        scrollTop: self.currentScrollPoints.y,
        showScrollBar: true
      })
    }, 200);
  },

  // onMouseDown: function (e) {
  //   e.stopPropagation();
  //   this.mousePress = true;
  //   this.downPoint = {
  //     x: e.nativeEvent.layerX,
  //     y: e.nativeEvent.layerY
  //   }
  // },
  //
  // onMouseUp: function (e) {
  //   e.stopPropagation();
  //   this.mousePress = false;
  // },
  //
  // onMouseLeave: function (e) {
  //   this.mousePress = false;
  // },
  //
  // onMouseMove: function (e) {
  //   var offsetX;
  //   var offsetY;
  //   // e.stopPropagation();
  //   if (this.ENABLED_DRAG) {
  //     if (this.mousePress) {
  //       offsetX = e.nativeEvent.layerX - this.downPoint.x;
  //       offsetY = e.nativeEvent.layerY - this.downPoint.y;
  //       this.doScrollBy(offsetX, offsetY);
  //       this.downPoint = {
  //         x: e.nativeEvent.layerX,
  //         y: e.nativeEvent.layerY
  //       }
  //     }
  //   }
  // },
  //
  // doScrollBy: function (x, y) {
  //   var content = ReactDOM.findDOMNode(this.refs.viewPort);
  //   var left = this.state.scrollLeft - x;
  //   var top = this.state.scrollTop - y;
  //   left = Math.min(left, content.clientWidth - styleHelper.getWidth(this.props));
  //   left = Math.max(left, 0);
  //   top = Math.min(top, content.clientHeight - styleHelper.getHeight(this.props));
  //   top = Math.max(top, 0);
  //   this.setState({
  //     scrollLeft: left,
  //     scrollTop: top
  //   });
  //   //$(content).css({left : left, top : top});
  //
  // },

  componentDidMount: function () {
    tool.setThumbOpaicty(ReactDOM.findDOMNode(this), 0);
    this.doBindEvent();
  },

  timerId: null,
  componentDidUpdate: function () {
    this.doBindEvent();
    this.doAutoHiddenBar();
  },

  doAutoHiddenBar: function() {

    var dom = ReactDOM.findDOMNode(this);
    var vertThumb = tool.getVertThumb(dom);
    var horiThumb = tool.getHoriThumb(dom);

    if(this.timerId) {
      clearTimeout(this.timerId);
    }
    $(vertThumb).css('opacity', 1);
    $(horiThumb).css('opacity', 1);
    this.timerId = setTimeout(function() {
      if(vertThumb) {
        $(vertThumb).animate({opacity:"0"}, 600);
      }
      if(horiThumb) {
        $(horiThumb).animate({opacity:"0"}, 600);
      }
    }, 800);

    if(this.hasShow) {
      this.hasShow = false;
    }
  },

  doBindEvent: function () {
    var dom = ReactDOM.findDOMNode(this);
    $(dom).off('onScrollTo');
    $(dom).on('onScrollTo', this.onScrollTo);
  },

  componentWillUnmount: function () {
    if (this.timeID) {
      clearTimeout(this.timeID);
    }
    if (this.autoScrolltimeID) {
      clearTimeout(this.autoScrolltimeID);
    }
    if (this.requestID) {
      cancelAnimationFrame(this.requestID);
    }
  },

  onScrollTo: function (event, controlID, params, complete) {
    var targetTop = Math.abs(params.top);
    var self = this;
    var call = function () {
      self.currentScrollPoints.y = targetTop;
      if (complete) {
        complete();
      }
    };
    if (this.state.scrollTop !== this.currentScrollPoints.y) {
      this.setState(
        {
          scrollLeft: this.currentScrollPoints.x,
          scrollTop: this.currentScrollPoints.y
        }
      );
    }

    //params.useAnimate = true;

    if (params.useAnimate) {
      this.doLinerAnimateScrollTo(controlID, targetTop, call);
    } else {
      this.doNoAnimateScrollTo(controlID, targetTop, call);
    }
  },

  doNoAnimateScrollTo: function (controlID, top, complete) {
    if (controlID === this.props.controlID) {
      this.setState({scrollTop: top});
      if (complete) {
        complete();
      }

    }
  },

  doLinerAnimateScrollTo: function (controlID, top, complete) {
    var targetTop = top;
    var view = ReactDOM.findDOMNode(this.refs.scrollbox);
    view = $(view).children('.scroll-content')[0];
    var oldTop = Math.abs(view.scrollTop);
    var step = Math.max(40, Math.abs(targetTop - oldTop) / 10);
    var self = this;
    var currentTop = oldTop;
    var isFinish = false;
    if (targetTop < oldTop) {
      step *= -1;
    }

    var doScroll = function () {
      self.requestID = window.requestAnimationFrame(function () {
        currentTop += step;
        if (targetTop < oldTop) {
          if (currentTop < targetTop) {
            currentTop = targetTop;
          }
        } else if (targetTop > oldTop) {
          if (currentTop > targetTop) {
            currentTop = targetTop;
          }
        }
        self.setState({scrollTop: currentTop});
        if (currentTop === targetTop) {
          isFinish = true;
        }
        if (!isFinish) {
          self.timeID = setTimeout(doScroll, 10);
        } else {
          if (complete) {
            complete();
          }
        }
      });
    };
    if (controlID === this.props.controlID) {
      if (targetTop !== oldTop) {
        doScroll();
      } else {
        if (complete) {
          complete();
        }
      }
    }
  }
});

module.exports = ScrollView;



// WEBPACK FOOTER //
// ./src/views/Components/ScrollView.jsx